import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import useCartLogic from './CartLogic';
import BasicCartSkin from './skins/BasicCartSkin';

/**
 * 장바구니 스킨 가능 컴포넌트
 */
export const CartSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.CART,
  name: '장바구니',
  category: 'ecommerce',
  supportsExternalSkins: true,
  options: [],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicCartSkin as any
  },
  useLogic: useCartLogic as any,
  defaultProps: {
    title: '장바구니',
    emptyText: '장바구니가 비어 있습니다.',
    shippingFee: 4000,
    freeShippingThreshold: 50000,
    showStock: true,
    showImage: true,
    showQuantitySelector: true,
    showRemoveButton: true,
    showCoupon: true,
    showSummary: true,
    showCheckout: true,
    primaryButtonColor: '#007bff',
    secondaryButtonColor: '#6c757d',
    dangerButtonColor: '#dc3545',
    priceColor: '#ff6b6b',
    summaryBackgroundColor: '#f8f9fa'
  }
};